export const money = (paise: number) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(paise / 100);

export const formatDate = (iso: string) => new Date(iso).toLocaleDateString('en-IN');

export const formatDateTime = (iso: string) => new Date(iso).toLocaleString('en-IN');

/** Turn API enum values such as `in_transit` into readable text. */
export const humanize = (value: string) => value.replace(/_/g, ' ');

/** Short, human-facing prefix of a UUID. */
export const shortId = (id: string) => id.slice(0, 8);
